import { compute } from '@exodus/atoms'

const createLocalSeedBackupsAtom = ({ wallet, localSeedPrivateBackupsAtom }) => {
  const selector = async (localSeedBackups) => {
    const currentMnemonic = await wallet.getMnemonic().catch(() => null)

    return localSeedBackups.map(({ mnemonic, dateCreated, dateBackedUp }, index) => {
      const [prefix] = mnemonic.split(' ').slice(0, 1)
      const isCurrent = mnemonic === currentMnemonic
      return { index, prefix, isCurrent, dateCreated, dateBackedUp }
    })
  }

  return compute({ atom: localSeedPrivateBackupsAtom, selector })
}

export default createLocalSeedBackupsAtom
